import React from 'react';
import './ContentSectionInspector.css';

function ContentSectionInspector({ func, index, onUpdate }) {
  const handleChange = (key, value) => {
    const newProps = {
      ...func.props,
      [key]: value
    };
    onUpdate(index, newProps);
  };

  const handleScheduleItemChange = (itemIndex, field, value) => {
    const newScheduleItems = [...(func.props.scheduleItems || [])];
    newScheduleItems[itemIndex] = {
      ...newScheduleItems[itemIndex],
      [field]: value
    };
    handleChange('scheduleItems', newScheduleItems);
  };

  const addNewScheduleItem = () => {
    const newScheduleItems = [...(func.props.scheduleItems || []), {
      time: '12:00',
      event: ''
    }];
    handleChange('scheduleItems', newScheduleItems);
  };

  const removeScheduleItem = (itemIndex) => {
    const newScheduleItems = func.props.scheduleItems.filter((_, idx) => idx !== itemIndex);
    handleChange('scheduleItems', newScheduleItems);
  };

  return (
    <div className="content-section-inspector">
      <div className="input-group">
        <label>Section Title</label>
        <input
          type="text"
          value={func.props.sectionTitle || 'Schedule of Events'}
          onChange={(e) => handleChange('sectionTitle', e.target.value)}
          className="full-width-input"
        />
      </div>

      <div className="schedule-items">
        <h4>Schedule Items</h4>
        {(func.props.scheduleItems || []).map((item, idx) => (
          <div key={idx} className="schedule-item">
            <div className="time-input">
              <input
                type="time"
                value={item.time}
                onChange={(e) => handleScheduleItemChange(idx, 'time', e.target.value)}
                className="time-picker"
              />
            </div>
            <div className="event-input">
              <input
                type="text"
                value={item.event}
                onChange={(e) => handleScheduleItemChange(idx, 'event', e.target.value)}
                placeholder="Event description"
                className="event-field"
              />
            </div>
            <button 
              onClick={() => removeScheduleItem(idx)}
              className="remove-button"
              title="Remove item"
            >
              ×
            </button>
          </div>
        ))}
        <button 
          onClick={addNewScheduleItem}
          className="add-button"
        >
          + Add Schedule Item
        </button>
      </div>
    </div>
  );
}

export default ContentSectionInspector; 